import React from 'react';

interface IAffiliatesTable {
  affiliate: any;
  tab: string;
  setSearch: any;
  setBrowseMode: any;
  setAddMode: any;
  setEditMode: any;
  handleTabSwitch: any;
  removeMember: any;
  unfollowAffiliate: any;
}

const AffiliatesTable: React.FC<IAffiliatesTable> = (
  {
    affiliate,
    tab,
    setSearch,
    setBrowseMode,
    setAddMode,
    setEditMode,
    handleTabSwitch,
    removeMember,
    unfollowAffiliate
  }
) => {
  const convertTimestamp = (time: any) => {
    let date: any = new Date(time);
    date = date.toLocaleDateString();
    return date;
  };

  return (
    <div className='affiliate-list-container'>
      <div className='affiliate-list-frame'>
        <div className='affiliate-list-table'>
          <div className='affiliate-list-header'>
            <div className='affiliate-list-header-content'>
              <div className='affiliate-list-header-group'>
                <div className='affiliate-list-header-group-text'>
                  <div className='affiliate-list-header-group-text-frame'>
                    {!affiliate.isLoading && affiliate.data !== undefined ? (
                      <div className='affiliate-list-header-group-text-primary'>
                        Affiliates
                      </div>
                    ) : (
                      <div className='affiliate-list-header-group-text-primary'>
                        Following
                      </div>
                    )}
                  </div>
                  {!affiliate.isLoading && affiliate.data !== undefined && (
                    <>
                      <div className='affiliate-list-header-search'>
                        {/* <div className='affiliate-list-header-search-frame'>
                          <input
                            className='affiliate-list-header-search-input'
                            placeholder='Search affiliates'
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </div> */}
                      </div>
                      {tab === 'following' ? (
                        <div className='browse-affiliates-btn' onClick={() => setBrowseMode(true)}>
                          <div className='browse-affiliates-btn-text'>
                            Browse Affiliates
                          </div>
                          <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
                            <path d='M10.5 4.16675V15.8334M4.66667 10.0001H16.3333' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                          </svg>
                        </div>
                      ) : (
                        <div className='add-affiliate-btn' onClick={() => setAddMode(true)}>
                          <div className='add-affiliate-btn-text'>
                            + Add Affiliate
                          </div>
                        </div>
                      )}
                      <div className='browse-affiliates-btn' onClick={() => setEditMode(true)}>
                        <div className='browse-affiliates-btn-text'>
                          Edit
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {!affiliate.isLoading && affiliate.data !== undefined && (
                <div className='affiliate-list-tabs'>
                  <div className='affiliate-list-tabs-content'>
                    <div
                      onClick={() => handleTabSwitch('members')}
                      className={`affiliate-list-tabs-btn${tab === 'members' ? '-selected' : ''}`}
                    >
                      <div className={`affiliate-list-tabs-btn${tab === 'members' ? '-selected' : ''}-text`}>
                        Members
                      </div>
                    </div>
                    <div
                      onClick={() => handleTabSwitch('following')}
                      className={`affiliate-list-tabs-btn${tab === 'following' ? '-selected' : ''}`}
                    >
                      <div className={`affiliate-list-tabs-btn${tab === 'following' ? '-selected' : ''}-text`}>
                        Following
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {!affiliate.isLoading && !affiliate.data ? (
            <div className='affiliate-list-body-none'>
              <div className='affiliate-list-none-text'>
                Not following any affiliations
              </div>
              <div className='browse-affiliates-btn' onClick={() => setBrowseMode(true)}>
                <div className='browse-affiliates-btn-text'>
                  Browse Affiliates
                </div>
                <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
                  <path d='M10.5 4.16675V15.8334M4.66667 10.0001H16.3333' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
            </div>
          ) : (
            <div className='affiliate-list-body'>
              <div className='affiliate-list-head-columns'>
                <div className='affiliate-list-head-column-cell'>
                  <div className='affiliate-list-head-column-cell-inner'>
                    <div className='affiliate-list-head-column-cell-text'>
                      Name
                    </div>
                  </div>
                </div>
                {tab === 'members' ? (
                  <div className='affiliate-list-head-column-cell'>
                    <div className='affiliate-list-head-column-cell-inner'>
                      <div className='affiliate-list-head-column-cell-text'>
                        Date Joined
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='affiliate-list-head-column-cell'>
                    <div className='affiliate-list-head-column-cell-inner'>
                      <div className='affiliate-list-head-column-cell-text'>
                        Date Followed
                      </div>
                    </div>
                  </div>
                )}
                <div className='affiliate-list-head-column-cell-placeholder'></div>
              </div>
              {!affiliate.isLoading && tab === 'following' && affiliate.data?.following?.map((following: any, index: number) => (
                <div key={index} className='affiliate-list-head-columns'>
                  <div className='affiliate-list-row-cell'>
                    <div className='affiliate-list-row-cell-primary'>
                      {following.name}
                    </div>
                  </div>
                  <div className='affiliate-list-row-cell'>
                    <div className='affiliate-list-row-cell-secondary'>
                      {convertTimestamp(following.dateJoined)}
                    </div>
                  </div>
                  <div className='affiliate-list-row-cell-placeholder'>
                    <div className='affiliate-list-row-cell-placeholder-btn' onClick={() => unfollowAffiliate(affiliate.data, following, index)}>
                      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                        <path d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
              {!affiliate.isLoading && tab === 'members' && affiliate.data?.members?.map((member: any, index: number) => (
                <div key={index} className='affiliate-list-head-columns'>
                  <div className='affiliate-list-row-cell'>
                    <div className='affiliate-list-row-cell-primary'>
                      {member.name}
                    </div>
                  </div>
                  <div className='affiliate-list-row-cell'>
                    <div className='affiliate-list-row-cell-secondary'>
                      {convertTimestamp(member.dateJoined)}
                    </div>
                  </div>
                  <div className='affiliate-list-row-cell-placeholder'>
                    <div className='affiliate-list-row-cell-placeholder-btn' onClick={() => removeMember(affiliate.data, member, index)}>
                      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                        <path d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* <div className='affiliate-list-pagination'>
            <div className='affiliate-list-pagination-text'>
              Page 1 of 1
            </div>
            <div className='affiliate-list-page-actions'>
              <div className='affiliate-list-page-btn-disabled'>
                <div className='affiliate-list-page-btn-text-disabled'>
                  Previous
                </div>
              </div>
              <div className='affiliate-list-page-btn-disabled'>
                <div className='affiliate-list-page-btn-text-disabled'>
                  Next
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AffiliatesTable;
